import { Sidebar } from "../Sidebar";
import { UserProfileModal } from "../UserProfileModal";
import { useAuth } from "../../contexts/AuthContext";

export const Layout = ({ children }) => {
  const { showProfileModal, setShowProfileModal } = useAuth();

  return (
    <>
      <Sidebar />
      {children}
      <UserProfileModal
        open={showProfileModal}
        onClose={() => setShowProfileModal(false)}
      />
    </>
  );
};
